import { render, staticRenderFns } from "./pProjectDetail.vue?vue&type=template&id=fe20c39c&scoped=true"
import script from "./pProjectDetail.vue?vue&type=script&lang=js"
export * from "./pProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./pProjectDetail.vue?vue&type=style&index=0&id=fe20c39c&prod&lang=scss&scoped=true"
import style1 from "./pProjectDetail.vue?vue&type=style&index=1&id=fe20c39c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe20c39c",
  null
  
)

export default component.exports